import {createStyles, makeStyles} from '@material-ui/core';
import {
  DRAGGABLE_ITEM_BOX_SHADOW,
  FONT_PRIMARY_COLOR
} from 'src/style/variable';

export const DraggableTicketingSystemTicketTimerCardStyles = makeStyles(() =>
  createStyles({
    ticketFloatCardHeader: {
      alignItems: 'center',
      gap: '2rem',
      '& .MuiCardHeader-action': {
        margin: 0
      },
      cursor: 'move'
    },
    ticketFloatCard: {
      position: 'absolute',
      bottom: 20,
      left: 20,
      zIndex: 1250,
      boxShadow: DRAGGABLE_ITEM_BOX_SHADOW,
      lineHeight: '1em',
      maxWidth: 400,
      width: '100%',
      maxHeight: '90vh',
      overflow: 'auto'
    },
    ticketFloatCardHeaderWrapper: {
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
      borderBottom: '1px solid #eeeeee',
      paddingBlock: '0.5rem',
      fontWeight: 'bold',
      fontSize: '1.5rem',
      letterSpacing: '0.03em'
    },
    ticketPanelDragIcon: {
      cursor: 'move'
    },
    ticketTimerWrapper: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '3rem'
    },
    ticketPanelInfoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    link: {
      padding: 0,
      fontWeight: 'normal'
    },
    ticketPatientInfoWrapper: {
      paddingTop: 0,
      color: '#54585b',
      display: 'grid',
      gap: '0.75rem',
      marginTop: '0.5rem',
      gridTemplateColumns: 'max-content min-content 1fr'
    },
    ccmButtonWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '0.5rem'
    },
    ticketPatientDetailsHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 'bold',
      lineHeight: 1
    },
    cardContent: {
      paddingTop: 0
    },
    textArea: {
      height: 'auto',
      paddingBottom: 0,
      marginBottom: 0,
      '& .MuiInputBase-root': {
        paddingBlock: '1rem',
        paddingInline: '0.75rem',
        height: 50,
        color: FONT_PRIMARY_COLOR
      },
      opacity: 1
    },
    ticketPatientInfoCardContent: {
      paddingBlock: 0
    }
  })
);
